import type { EntrySlice } from '../types'
import { isTaskEntry } from './guard'
import { TaskRow } from './row'
import type { TaskEntry } from './meta'
import type { TaskDraft } from './write-spec'

/**
 * The task kind's adapter behind the entry-kind seam.
 *
 * `editForm` is a real member here, which is what #311's split bought: while `TaskEditForm` was an
 * unexported function inside `task-row.tsx`, nothing could name it.
 */
export const taskSlice: EntrySlice<TaskEntry, TaskDraft> = {
  guard: isTaskEntry,
  row: TaskRow,
  editForm: null,
}
